module.exports = __webpack_public_path__ + "img/icons_12.d7e4c8b9.png";